import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { UsersCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { UsersTable } from "./table";
import { UsersNewCard } from "./new";

export default function Users() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Utilisateurs");
  }, []);

  return (
    <Routes>
      <Route index element={<UsersTable />} />
      <Route path=":id" element={<UsersCard />} />
      <Route path="/new" element={<UsersNewCard />} />
    </Routes>
  );
}
